import { IParticipationResponse, IParticipationSummary } from "@Interfaces";

/**
 * The only place that turns the backend response into the numbers the widgets show,
 * so each displayed value can be checked against the CSV export in one spot.
 *
 * "Answers" are answered questions per respondent (distinct SIDs per question), so
 * total_answers is the sum over questions and the average can never exceed the
 * question count.
 */
export const toParticipationSummary = (
    response: IParticipationResponse
): IParticipationSummary => {
    const totalAnswers = response.questions.reduce(
        (sum, question) => sum + question.answered_respondent_count,
        0
    );

    return {
        channel_id: response.channel_id,
        qr_scans: response.qr_scan_count,
        respondents: response.respondent_count,
        total_answers: totalAnswers,
        avg_answers_per_respondent:
            response.respondent_count > 0
                ? totalAnswers / response.respondent_count
                : 0,
        respondents_answered_all: response.completed_respondent_count,
        questions_count: response.question_count,
        respondents_wrote_something: response.people_wrote_something_count,
        answers_per_question: response.questions.map((question) => ({
            question_id: question.question_id,
            question_text: question.question,
            answered_count: question.answered_respondent_count,
        })),
        top_question: response.top_question
            ? {
                  question_id: response.top_question.question_id,
                  question_text: response.top_question.question,
                  poll_type: response.top_question.poll_type,
                  options: response.top_question.options,
              }
            : null,
        attendee_count: response.attendee_count,
    };
};
